module.exports = __webpack_public_path__ + "static/media/eg.38061656.webp";